<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-value="material_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-slot:item="{ item }">
      <span
        v-if="item.standard_name && item.standard_name.length > 12"
        :title="item.standard_name"
        style="cursor: pointer"
      >
        {{ item.Description }}
      </span>
      <span v-else>
        {{ item.Description }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockMaterials from "@/api/stock_materials";

export default {
  name: "SearcherStockMaterial",

  props: {
    stockId: Number,
    value: Object,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    exitStockDetail: Number,
    stockType: Number,
    showMaterials: Boolean,
  },

  computed: {
    materialsItems() {
      return this.materials.map((material) => {
        const Description = this.dense
          ? material.material_name
          : i18n.t("Material.materialNameWithCodeAndStandard", [
              material.material_code,
              material.material_name,
              material.standard_name && material.standard_name.length > 12
                ? material.standard_name.slice(0, 12) + "......"
                : material.standard_name,
            ]);
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == material.material_id
            )
          : false;
        return Object.assign({}, material, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
    monitorTime: null,
  }),

  methods: {
    getMaterialsFromAPI() {
      this.materialsLoading = true;
      var options = { stock_id: this.stockId };
      if (this.stockType) {
        if (this.stockType == 1) {
          //销售出库选择非原料属性商品
          options = Object.assign({}, options, {
            raw_material_flg: 0,
          });
        } else if (this.stockType == 12) {
          //领料出库选择原料属性商品
          options = Object.assign({}, options, {
            raw_material_flg: 1,
          });
        } else if (this.stockType == 2) {
          //调拨出库选有库存商品
          options = Object.assign({}, options, {
            inventory_flg: 1,
          });
        }
      } else {
        options = {};
      }
      StockMaterials.fetchAll(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.stock_materials;
            }
            this.materialsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        if (this.materialsSelected && this.materialsSelected.id)
          this.$emit("input", this.materialsSelected);
      },
    },
    stockId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.stockId != "undefined" && this.stockId != null)
          this.getMaterialsFromAPI();
      },
    },
    stockType: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.stockType != "undefined" && this.stockType != null)
          this.getMaterialsFromAPI();
      },
    },
    showMaterials: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.showMaterials) this.getMaterialsFromAPI();
      },
    },
  },
};
</script>
